import React from "react";
import PropTypes from "prop-types";

import { Header } from "./components";

const Main = (props) => {
  const { children } = props;

  return (
    <div>
      <Header />
      <div className="wrapper">
        <main className="w-100">{children}</main>
      </div>
    </div>
  );
};

Main.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Main;
